const state = {
  products: null
};

const getters = {
  getProducts: state => state.products
};

const actions = {};

const mutations = {
  setProducts(state, payload) {
    state.products = payload;
  },
  addProducts(state, payload) {
    state.products = [...state.products, ...payload];
  },
  reset(state) {
    state.products = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
